import { AmplitudeAnalyticsLogger } from './lib/amplitude-analytics-logger';

export { AmplitudeAnalyticsLogger };

export default new AmplitudeAnalyticsLogger();
